import { RowActionIndicator } from '@/components/atoms/RowActionIndicator/RowActionIndicator';
import { focusVisibleRing } from '@/components/ui/constants';
import { cn } from '@/lib/utils';

import { DuplicateAction, RoleActionsMenu } from './RoleActionsMenu';
import { CARD_CLASSES } from './RoleCard';

type Props = {
  name: string;
  canWrite: boolean;
  canDelete: boolean;
  isRenaming?: boolean;
  duplicate: DuplicateAction;
  onRename: (name: string, opts: { onSuccess: () => void }) => void;
  onEdit: () => void;
  onDelete: () => void;
};

export const CustomRoleCard = ({
  name,
  canWrite,
  canDelete,
  isRenaming,
  duplicate,
  onRename,
  onEdit,
  onDelete,
}: Props) => (
  <div className={cn(CARD_CLASSES, 'group hover:bg-highlight-background')}>
    <button
      type="button"
      onClick={onEdit}
      className={cn(
        'flex min-w-0 flex-1 items-center gap-2 self-stretch rounded-l-lg p-4 text-left',
        focusVisibleRing
      )}
    >
      <div className="min-w-0 flex-1">
        <p className="text-sm leading-5 font-semibold text-foreground">{name}</p>
      </div>
      <RowActionIndicator action="open" />
    </button>

    <div className="py-4 pr-4">
      <RoleActionsMenu
        name={name}
        canWrite={canWrite}
        canDelete={canDelete}
        isRenaming={isRenaming}
        duplicate={duplicate}
        onRename={onRename}
        onEdit={onEdit}
        onDelete={onDelete}
      />
    </div>
  </div>
);
